<script lang="ts" setup>
import DirectionColumnIfMobileContainer from '../../DirectionColumnIfMobileContainer.vue';
import ResearchDataCard from '../../ResearchData/ResearchDataCard.vue';
import Img1 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/4_1.jpeg/4_1.webp';
import Img2 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/4_2.jpeg/4_2.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  num: number;
}>();
</script>

<template>
  <ResearchDataCard :num="num" :class="$style.container">
    <template #title>
      <strong
        >物件価格は世帯年収400万円未満では「3,000万円未満」、世帯年収1,200万円以上では「4,000万円以上5,000万円未満」が最も多い結果に</strong
      >
    </template>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img1" alt="グラフ" />
      <div>
        <p>
          既にマイホームを所有している方へ「物件価格（土地代含む）」について質問したところ、
          <strong
            >3,000万円未満が最も多く28.8%、次いで3,000万円以上4,000万円未満26.1％</strong
          >となりました。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img2" alt="グラフ" />
      <div>
        <p>
          世帯年収別では、
          <strong>世帯年収400万円未満では「3,000万円未満」、</strong>
          世帯年収600万円以上1,200万未満は「3,000万円以上4,000万円未満」、
          <strong
            >世帯年収1,200万円以上では「4,000万円以上5,000万円未満」の物件が最も多く購入</strong
          >されていることが分かりました。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
  </ResearchDataCard>
</template>

<style lang="scss" module>
.container {
  :nth-child(n + 2) {
    margin-top: 8px;
  }
}
</style>
